// extracted by mini-css-extract-plugin
module.exports = {"orderActions":"VIP_OrderManagementActions__orderActions","circularProgress":"VIP_OrderManagementActions__circularProgress","disabled":"VIP_OrderManagementActions__disabled"};